import { Injectable, inject } from '@angular/core';
import { ApiService } from '@app/gateway';
import { SyncFactory, SyncModel } from '../models';

@Injectable({ providedIn: 'root' })
export class SyncService {
  private readonly apiService = inject(ApiService);

  public async getSync(): Promise<SyncModel[]> {
    try {
      const path: string = `${SyncFactory.getPath()}`;
      const sync: SyncModel[] = await this.apiService.get<SyncModel[]>({ path });
      return sync;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }
}
